import request from '@/http/request'
import {
  registerUserExport,
  registerUserExcelTempCreate,
  registerUserImport,
  importRegisterUserPhoto,
  addRegisterUserInfo,
  selectRegisterUserByOne,
  updateRegisterUserInfo,
  deleteRegisterUserInfo
} from '@/http/api'





// 查询
export const DeleteUser = data => {
  return request({
    url: deleteRegisterUserInfo,
    method: 'GET',
    params: data
  })
}
export const Update = data => {
  return request({
    url: updateRegisterUserInfo,
    data
  })
}
// 查询
export const SelectUser = data => {
  return request({
    url: selectRegisterUserByOne,
    method: 'GET',
    params: data
  })
}
// 导出
export const Export = (data) => {
  return request({
    url: registerUserExport,
    data
  })
}
//模板下载
export const Excel = (data) => {
  return request({
    url: registerUserExcelTempCreate,
    data
  })
}
//批量导入数据
export const Import = (data) => {
  return request({
    url: registerUserImport,
    data,
    isUpload:true
  })
}
//批量上传照片
export const ImportPhoto = (data) => {
  return request({
    url: importRegisterUserPhoto,
    data,
    isUpload:true
  })
}
//新增学生
export const addUser = (data) => {
  return request({
    url: addRegisterUserInfo,
    data
  })
}
